export const formatErrorDetail = (errorOrDetail, fallback = 'Произошла ошибка') => {
  const extract = (value) => {
    if (!value && value !== 0) return '';
    if (typeof value === 'string') return value;
    if (Array.isArray(value)) {
      return value
        .map((item) => extract(item?.msg || item?.message || item?.detail || item))
        .filter(Boolean)
        .join('; ');
    }
    if (typeof value === 'object') {
      return (
        value?.msg ||
        value?.message ||
        value?.error ||
        value?.detail ||
        JSON.stringify(value)
      );
    }
    return String(value);
  };

  const detail =
    errorOrDetail?.response?.data?.detail ??
    errorOrDetail?.detail ??
    errorOrDetail;

  const text = extract(detail);
  return text || fallback;
};

